<template>
	<div class="inputFieldContainer">
		<!--	Wrapped the Input with a clientOnly element to remove hydration console logs, not sure why this is happening	-->
		<ClientOnly>
			<label
				:for="id"
				class="inputFieldLabel"
				:class="labelColor"
				>{{ label }}
				<FormRequiredAsterisk :required="required" />
				<FormTooltip
					v-if="!!tooltipMsg"
					:tooltip-msg="tooltipMsg" />
			</label>
			<input
				:id="id"
				:autocomplete="autocomplete"
				:type="type"
				:placeholder="placeholder"
				v-model="value"
				class="inputField"
				:class="{ inputFieldError: hasError }"
				:disabled="disabled"
				@input="emitEvent('input')"
				@blur="emitEvent('blur')"
				@change="emitEvent('changed')" />
			<label
				:for="id"
				v-if="hasError && errorMessage"
				class="inputFieldErrorLabel"
				>{{ errorMessage }}</label
			>
		</ClientOnly>
	</div>
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()

	const { id, initialValue, disableAutocomplete } = defineProps({
		id: {
			type: String,
			default: "inputField",
		},
		label: {
			type: String,
			default: "Field Label",
		},
		labelColor: {
			type: String,
			default: "text-primary",
		},
		type: {
			type: String,
			default: "text",
		},
		placeholder: {
			type: String,
			default: "",
		},
		required: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: "",
		},
		initialValue: {
			type: String,
			default: "",
		},
		tooltipMsg: {
			type: String,
			default: "",
		},
		disableAutocomplete: {
			type: Boolean,
			default: false,
		},
	})

	const autocomplete = disableAutocomplete || runtimeConfig.public.IS_KIOSK_APP ? "dsadsa" : ""

	const emits = defineEmits(["input", "changed", "blur"])
	const value = ref(initialValue)

	const emitEvent = (eventName) => {
		emits(eventName, { id: id, value: value.value })
	}
</script>

<style scoped></style>
